module.exports = __webpack_public_path__ + "img/下一步.c5a29dbe.svg";